module.exports = __webpack_public_path__ + "img/youtube.cdb69593.png";